import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, TextField, Button, CardMedia, Input, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React, { ChangeEvent, useState } from "react";

const AddBooking = () => {
  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Add Customer</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-customers")}>Manage Customers</span>
          {' '} - Add Customer
        </p>
      </div>
      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia
                        component="img"
                        image={image}
                        alt="photo"
                      />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label
                  className="upload_image"
                  htmlFor="icon-button-file"
                >
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(
                      event: ChangeEvent<HTMLInputElement>
                    ) => {
                      const files = (
                        event.target as HTMLInputElement
                      ).files;
                      if (
                        files &&
                        files[0].type.includes("image")
                      ) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage(
                          "This field only accepts images."
                        );
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="icon"
                        />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_50">
              <label>Name</label>
              <TextField placeholder="Enter Name" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_50">
              <label>Email Id</label>
              <TextField placeholder="Enter Email Id" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_50">
              <label>Phone Number</label>
              <TextField placeholder="Enter Phone Number" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_50">
              <label>Address</label>
              <TextField placeholder="Enter Address" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_25">
              <label>City</label>
              <TextField placeholder="Enter City" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_25">
              <label>State</label>
              <TextField placeholder="Enter State" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_25">
              <label>Country</label>
              <TextField placeholder="Enter Country" hiddenLabel fullWidth></TextField>
            </div>
            <div className="control_group w_25">
              <label>Zip Code</label>
              <TextField placeholder="Enter Zip Code" hiddenLabel fullWidth></TextField>
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-customers")}>Save</Button>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default AddBooking;
